import axios from '@/axios.js'

export default {
  getPromoAssets: async (appUuid) => {
    try {
      const response = await axios.editorapi.get(`v4/apps/${appUuid}/promo-assets`)
      return response.data.object
    } catch (error) {
      throw new Error(error)
    }
  }
}
